<h1 class="mc-tt" *ngIf="!isLoading && getName()"> Hola {{ getPrimerNombre() }} </h1>

<!-- 1. Nivel, puntos y progreso al nivel siguiente -->
<div class="mc-blk">
  <app-resumen-puntos [model]="model" [orders]="ultimasCompras"></app-resumen-puntos>
</div>

<!-- 2. Mascotas -->
<div class="mc-blk">
  <app-mis-mascotas-resumen [pets]="model?.pets"></app-mis-mascotas-resumen>
</div>

<!-- 3. Beneficios del nivel actual -->
<div class="mc-blk">
  <app-beneficios-resumen [nivel]="model?.fidelidadPointsTotal?.nombreTier"></app-beneficios-resumen>
</div>

<!-- 4. Historial reciente (reemplaza "Ultimas compras"): 3 lineas del historial
     de puntos + link al historial completo. -->
<div class="mc-blk">
  <app-historial-reciente></app-historial-reciente>
</div>

<!-- Estado de cliente sin datos consolidados. No esta en el prototipo, pero es
     un estado real del sistema y sacarlo dejaria al usuario sin saber por que
     no ve nada. -->
<mat-card class="card-name-invalid" *ngIf="!isLoading && !getName()">
  <h1 class="home-name"> Bienvenido </h1>

  <div class="alert-name" *ngIf="!model?.verificado" style="margin-bottom: 4px;">
    <mat-icon>warning</mat-icon> <span> Usuario no verificado  </span>
  </div>

  <div class="alert-name" >
    <mat-icon>warning</mat-icon> <span> Se requiere validar datos personales  </span>
  </div>
</mat-card>

<loading-indicator *ngIf="isLoading"></loading-indicator>
